<div fxFlex fxLayoutAlign="center center">
	<mat-spinner
		*ngIf="utilService.isNullOrUndefined(carriersList) && isLoadingCarrier"
		[diameter]="30"
	></mat-spinner>

	<mat-form-field
		*ngIf="!utilService.isNullOrUndefined(carriersList) && !isLoadingCarrier && useSelect"
		fxFlex
	>
		<mat-label>Select carrier</mat-label>
		<mat-select (selectionChange)="carrierSelected($event.value)">
			<mat-option *ngFor="let carrier of carriersList" [value]="carrier">
				{{ carrier.businessName }}
			</mat-option>
		</mat-select>
	</mat-form-field>

	<mat-form-field
		*ngIf="!utilService.isNullOrUndefined(carriersList) && !isLoadingCarrier && useAutoComplete"
		fxFlex
	>
		<mat-chip-list #chipList>
			<mat-chip
				(removed)="chips.length = 0; carrierSelected(null)"
				*ngFor="let carrier of chips"
				[removable]="removable"
				[selectable]="selectable"
			>
				{{ carrier.businessName }}
				<mat-icon class="primary-light-color" matChipRemove>cancel</mat-icon>
			</mat-chip>
			<input
				#carrierInput
				[disabled]="chips.length > 0"
				[formControl]="carrierListCtrl"
				[matAutocomplete]="auto"
				[matChipInputFor]="chipList"
				[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
				placeholder="{{ inputPlaceholder }}"
			/>
		</mat-chip-list>

		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="addChip($event, carrierInput)">
			<mat-option *ngFor="let carrier of filteredOptions" [value]="carrier">
				{{ carrier.businessName }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</div>
